<template>
  <div class="mobile_render_banner">
    <div id="Swip" ref="swiper" class="swiper-container">
      <div class="swiper-wrapper">
        <div
          v-for="(item, index) in applicationInfo"
          :key="index"
          class="swiper-slide"
        >
          <img  :src="item.imgUrl" alt="" @click="handleClickStudioVideo(item)"/>
          <div class="lighting_text position_none_lighting_text">
            <p style="font-size: 20px; font-weight: 700; margin-bottom: 10px;">{{ item.title }}</p>
          </div>
          <p class="render_msg">{{ item.msg }}</p>
          <div class="mark">
          </div>
        </div>
      </div>
    </div>

    <videoPlayback
        v-if="studioVideoDetail"
        @close="handleClickCloseStudioVideoMask"
        :videoUrl="studioVideoDetail"
    />
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
import videoPlayback from "@/components/mobile/videoPlayback.vue";
export default {
  components: {
    videoPlayback,
  },

  data() {
    return {
      studioVideoDetail:''
    };
  },
  props: {
    applicationInfo: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    new Swiper(this.$refs.swiper, {
      autoplay: {
        delay: 2000,
        // 交互后保持自动播放
        disableOnInteraction: true,
      },
      pagination: {
        el: ".swiper-pagination",
        // 可点击
        clickable: true,
      },
      // 禁用滑动
      allowTouchMove: true,
    });
  },
  methods: {
    handleClickStudioVideo(item) {
      if(item && item.video_src){
        this.studioVideoDetail = item.video_src
      }
    },
    handleClickCloseStudioVideoMask() {
      this.studioVideoDetail = ''
    },
  }

};
</script>

<style lang="scss" scoped>
@import "@/styles/mobile_wsc.scss";

@media screen and (min-width: 768px){
  .mobile_render_banner {
    .swiper-wrapper {
      .swiper-slide {
        position: relative;

        img {
          margin: 10px 0;
          // width: 283.5px;

          width: 100%;
        }

        .lighting_text {
          p{
            font-size: 26px !important;
          }
          height: 64px;
          margin: 0 auto;
          text-align: left;

          // top: calc(5%);
          // left: calc(5%);
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
          &.position_none_lighting_text{
            position: static;
            height: auto;
            top: auto;
            left: auto;
            transform: translate(0%,0%);
          }
        }

        .render_msg {
          width: 100%;
          height: 80px;
          font-size: 18px;
          text-align: left;
          color: white;
        }


      }


    }
  }
}
</style>
